export default "__VITE_ASSET__D_6qjEUk__"